'use client'

import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface UnifiedPageProps {
  children: ReactNode
  className?: string
}

export function UnifiedPage({ children, className }: UnifiedPageProps) {
  return (
    <div className={cn('oorva-site-theme relative min-h-screen bg-background text-foreground', className)}>
      {/* Single fixed base so color-block sections layer cleanly on top */}
      <div className="fixed inset-0 bg-background -z-10" />

      <div className="relative z-10">{children}</div>
    </div>
  )
}
